import React, { useState, useEffect } from "react";

export default function StudentUniformCard() {
  // ✅ 初始值不为 null，避免空指针
  const [student, setStudent] = useState({});
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({
    uniform_id: "",
    student_name: "",
    gender: "男",
    class_name: "",
    phone: "",
    teacher: "",
    school: "",
    student_number: "",
  });
  const [error, setError] = useState("");
  const [logoError, setLogoError] = useState(false);

  // 从 URL 获取二维码 id
  const query = new URLSearchParams(window.location.search);
  const uniformId = query.get("id") || "TEST123";

  // 🎨 颜色主题配置表
  const themes = {
    鸦儿小学: { main: "#2563EB", gradient: "from-blue-50 to-indigo-100" },
    实验小学: { main: "#F59E0B", gradient: "from-yellow-50 to-orange-100" },
    黄城根小学: { main: "#10B981", gradient: "from-green-50 to-emerald-100" },
    default: { main: "#6366F1", gradient: "from-blue-50 to-indigo-100" },
  };

  // 🏫 学校 logo 对照表
  const schoolLogos = {
    黄城根小学: "黄城根小学.png",
    景山学校: "景山学校.png",
    实验小学: "实验小学.png",
  };

  // // ✅ 安全地取 logo 文件
  // const logoFile =
  //   schoolLogos[student?.school?.trim()] ||
  //   schoolLogos[form?.school?.trim()] ||
  //   "school-logo.png";
  // console.log("logoFile after calculation:", logoFile);

  // ✅ 当前主题颜色
  const currentTheme =
    themes[student?.school?.trim()] ||
    themes[form?.school?.trim()] ||
    themes.default;

  // ✅ 数据加载
  useEffect(() => {
    console.log("Logo Error State:", logoError);
    let didCancel = false;
    if (!uniformId) {
      setError("❌ 未检测到二维码编号 id 参数");
      setLoading(false);
      return;
    }

    const fetchData = async () => {
      try {
        const res = await fetch(
          `https://1367101423-hkd24jyuia.ap-beijing.tencentscf.com/?id=${uniformId}`
        );
        const data = await res.json();
        if (!didCancel) {
          console.log("✅ 查询结果：", data);
          if (data.exists) {
            setStudent(data.record);
          } else {
            setForm((f) => ({ ...f, uniform_id: uniformId }));
          }
          setLoading(false);
        }
      } catch (err) {
        if (!didCancel) {
          console.error("❌ 服务器响应错误详情:", err);
          setError("⚠️ 无法连接服务器：" + err.message);
          setLoading(false);
        }
      }
    };
    fetchData();

    return () => {
      didCancel = true;
    };
  }, []);

  // ✅ 绑定提交
  const handleSubmit = async () => {
    if (!form.school || !form.student_name) {
      alert("请填写完整信息（至少选择学校和姓名）！");
      return;
    }
    setError("");
    try {
      const res = await fetch(
        "https://1367101423-hkd24jyuia.ap-beijing.tencentscf.com/api/bind",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            action: "bind",
            uniform_id: form.uniform_id,
            student_name: form.student_name,
            gender: form.gender,
            class_name: form.class_name,
            student_number: form.student_number,
            phone: form.phone,
            teacher: form.teacher,
            school: form.school,
          }),
        }
      );

      const data = await res.json();
      console.log("📦 后端返回:", data);

      if (data.status === "ok" || data.success) {
        alert("✅ 绑定成功！");
        setStudent(data.record);
      } else {
        alert("❌ 绑定失败：" + (data.msg || "未知错误"));
      }
    } catch (err) {
      setError("❌ 提交失败：" + err.message);
    }
  };

  if (loading) return <div className="p-8 text-center">加载中...</div>;
  if (error) return <div className="p-8 text-red-500 text-center">{error}</div>;

  // ✅ 已绑定卡片
  if (student && student.student_name) {
    // ✅ 安全地取 logo 文件
    const logoFile =
      schoolLogos[student?.school?.trim()] ||
      schoolLogos[form?.school?.trim()] ||
      "school-logo.png";
    console.log("logoFile after calculation (inside bound card):", logoFile); // 👈 移到这里
    return (
      <div
        className={`min-h-screen flex justify-center items-center bg-gradient-to-br ${currentTheme.gradient} p-4`}
      >
        <div
          className="bg-white rounded-2xl shadow-lg w-full max-w-sm p-6 border transition-transform duration-300 hover:scale-[1.01]"
          style={{ borderColor: currentTheme.main }}
        >
          <div className="flex flex-col items-center">
            <img
              src={`/logos/${logoFile}`}
              alt="校徽"
              onError={() => setLogoError(true)}
              className="w-20 h-20 mb-2"
            />
            <h2
              className="text-xl font-bold mb-1"
              style={{ color: currentTheme.main }}
            >
              {student.school || "星辰中学"}
            </h2>
            <p className="text-gray-500 mb-4">电子身份卡</p>
          </div>
          <div className="space-y-2">
            <InfoRow label="学校" value={student.school} />
            <InfoRow label="姓名" value={student.student_name} />
            <InfoRow label="性别" value={student.gender} />
            <InfoRow label="班级" value={student.class_name} />
            <InfoRow label="学号" value={student.student_number || "—"} />
            {student.teacher && <InfoRow label="班主任" value={student.teacher} />}
            {student.phone && <InfoRow label="联系电话" value={student.phone} />}
          </div>
          <div className="mt-6 text-center text-sm text-gray-400">
            绑定时间：{new Date(student.bind_time).toLocaleString()}
          </div>

          {/* ✅ 显示校服编号 */}
          <div className="text-center text-sm text-gray-400 mt-1">
            校服编号：{student.uniform_id || "—"}
          </div>

        </div>
      </div>
    );
  }

  // ✅ 未绑定表单
  return (
    <div
      className={`min-h-screen flex justify-center items-center bg-gradient-to-br ${currentTheme.gradient} p-4`}
    >
      <div
        className="bg-white rounded-2xl shadow-lg w-full max-w-sm p-6 border transition-all"
        style={{ borderColor: currentTheme.main }}
      >
        <h2
          className="text-lg font-bold text-center mb-4"
          style={{ color: currentTheme.main }}
        >
          校服绑定信息
        </h2>

        <div className="space-y-3">
          {/* ✅ 学校改为下拉框 */}
          <FormRow
            label="学校"
            name="school"
            type="schoolSelect"
            form={form}
            setForm={setForm}
          />
          <FormRow label="姓名" name="student_name" form={form} setForm={setForm} />
          <FormRow
            label="性别"
            name="gender"
            type="select"
            form={form}
            setForm={setForm}
          />
          <FormRow label="班级" name="class_name" form={form} setForm={setForm} />
          <FormRow
            label="学号"
            name="student_number"
            form={form}
            setForm={setForm}
          />
          <FormRow label="班主任" name="teacher" form={form} setForm={setForm} />
          <FormRow label="联系电话" name="phone" form={form} setForm={setForm} />
        </div>

        <button
          onClick={handleSubmit}
          className="mt-6 w-full text-white py-2 rounded-lg hover:opacity-90 active:scale-95 transition-all"
          style={{ backgroundColor: currentTheme.main }}
        >
          立即绑定
        </button>

        {error && (
          <p className="mt-3 text-red-500 text-sm text-center">{error}</p>
        )}
      </div>
    </div>
  );
}

// 通用信息行
function InfoRow({ label, value }) {
  return (
    <div className="flex justify-between border-b py-1 text-gray-700">
      <span>{label}</span>
      <span className="font-medium">{value}</span>
    </div>
  );
}

// ✅ 通用表单行（支持性别 & 学校下拉）
function FormRow({ label, name, form, setForm, type = "text" }) {
  const handleChange = (e) =>
    setForm((prev) => ({ ...prev, [name]: e.target.value }));

  return (
    <div>
      <label className="text-gray-600 text-sm">{label}</label>

      {type === "select" ? (
        // 性别选择
        <select
          className="w-full border rounded-md p-2 mt-1"
          value={form[name]}
          onChange={handleChange}
        >
          <option>男</option>
          <option>女</option>
        </select>
      ) : type === "schoolSelect" ? (
        // ✅ 学校下拉选择框
        <select
          className="w-full border rounded-md p-2 mt-1"
          value={form[name]}
          onChange={handleChange}
        >
          <option value="">请选择学校</option>
          <option value="黄城根小学">黄城根小学</option>
          <option value="景山学校">景山学校</option>
          <option value="实验小学">实验小学</option>
          <option value="鸦儿小学">鸦儿小学</option>
          <option value="黄城根小学昌平分校">黄城根小学昌平分校</option>
        </select>
      ) : (
        // 普通文本输入框
        <input
          type="text"
          className="w-full border rounded-md p-2 mt-1"
          value={form[name]}
          onChange={handleChange}
        />
      )}
    </div>
  );
}